var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "block-editor openai-web-search" },
    [
      !_vm.channel
        ? _c(
            "section",
            [
              _c("a-result", {
                attrs: {
                  status: "warning",
                  title: "OpenAI API bağlantısı bulunamadı",
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "extra",
                      fn: function () {
                        return [
                          _c(
                            "div",
                            {
                              staticClass:
                                "d-flex align-items-center justify-content-center",
                            },
                            [
                              _c(
                                "SupsisButton",
                                {
                                  attrs: { primary: "", ghost: "" },
                                  on: { click: _vm.gotoOpenai },
                                },
                                [_vm._v("OpenAI ile Bağlantı Kur")]
                              ),
                            ],
                            1
                          ),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  688748461
                ),
              }),
            ],
            1
          )
        : [
            _vm._m(0),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "editor-row" },
              [
                _c("div", { staticClass: "editor-row-title" }, [
                  _vm._v("Arama Sorgusu"),
                ]),
                _vm._v(" "),
                _c("TiptapEditor", {
                  attrs: {
                    placeholder: "Arama sorgusu girin",
                    "show-attributes": true,
                    "show-emoji": false,
                  },
                  model: {
                    value: _vm.clone.query,
                    callback: function ($$v) {
                      _vm.$set(_vm.clone, "query", $$v)
                    },
                    expression: "clone.query",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "editor-row" },
              [
                _c("div", { staticClass: "editor-row-title" }, [
                  _vm._v("Arama Bağlamı Boyutu"),
                ]),
                _vm._v(" "),
                _c(
                  "a-select",
                  {
                    model: {
                      value: _vm.clone.search_context_size,
                      callback: function ($$v) {
                        _vm.$set(_vm.clone, "search_context_size", $$v)
                      },
                      expression: "clone.search_context_size",
                    },
                  },
                  [
                    _c("a-select-option", { attrs: { value: "low" } }, [
                      _vm._v("Düşük"),
                    ]),
                    _vm._v(" "),
                    _c("a-select-option", { attrs: { value: "medium" } }, [
                      _vm._v("Orta"),
                    ]),
                    _vm._v(" "),
                    _c("a-select-option", { attrs: { value: "high" } }, [
                      _vm._v("Yüksek"),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "editor-row" },
              [
                _c("div", { staticClass: "editor-row-title" }, [
                  _vm._v("Dahil Edilecek Alan Adları"),
                ]),
                _vm._v(" "),
                _vm._l(_vm.clone.include_domains, function (domain, index) {
                  return _c(
                    "div",
                    { key: "domain-" + index, staticClass: "key-value-pair" },
                    [
                      _c("a-input", {
                        staticClass: "domain-input",
                        attrs: { placeholder: "Alan adı (örn: example.com)" },
                        model: {
                          value: _vm.clone.include_domains[index],
                          callback: function ($$v) {
                            _vm.$set(_vm.clone.include_domains, index, $$v)
                          },
                          expression: "clone.include_domains[index]",
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "a-button",
                        {
                          attrs: { type: "link", danger: "" },
                          on: {
                            click: function ($event) {
                              return _vm.removeDomain(index)
                            },
                          },
                        },
                        [
                          _c("span", { staticClass: "material-icons" }, [
                            _vm._v("delete"),
                          ]),
                        ]
                      ),
                    ],
                    1
                  )
                }),
                _vm._v(" "),
                _c(
                  "a-button",
                  {
                    staticClass: "add-btn",
                    attrs: { type: "dashed", block: "" },
                    on: { click: _vm.addDomain },
                  },
                  [
                    _c("span", { staticClass: "material-icons" }, [
                      _vm._v("add"),
                    ]),
                    _vm._v(" Alan Adı Ekle\n            "),
                  ]
                ),
              ],
              2
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", { staticClass: "active-connection" }, [
      _c("div", { staticClass: "logos", attrs: { "data-small": "true" } }, [
        _c("div", { staticClass: "logo1" }, [
          _c("img", {
            staticClass: "custom-block-logo",
            attrs: { src: "/static/img/supsis-logo2.png" },
          }),
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "material-icons" }, [_vm._v(" add ")]),
        _vm._v(" "),
        _c("div", { staticClass: "logo2" }, [
          _c("img", { attrs: { src: "/static/img/openai.png" } }),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "active-connection-text" }, [
        _c("div", [
          _c("span", [_vm._v("OpenAI ile bağlantı kuruldu")]),
          _vm._v(" "),
          _c("b", [_vm._v("OpenAI")]),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }